export default __webpack_public_path__ + "static/media/HOM.10a7f368.png";